import React, {useEffect, useState} from "react";
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import exportsvg from '../assets/images/dashboard/export.svg';
import icon1 from '../assets/images/dashboard/icon1.svg';
import icon2 from '../assets/images/dashboard/icon2.svg';
import icon3 from '../assets/images/dashboard/icon3.svg';
import icon4 from '../assets/images/dashboard/icon4.svg';
import VisitorInsight from "../components/Charts/VisitorInsight";
import TotalRevenue from "../components/Charts/TotalRevenue";
import TargetReality from "../components/Charts/TargetReality";
import Customers from "../components/Charts/Customers";
import IndianMap from "../components/Charts/IndianMap";
import 'bootstrap/dist/css/bootstrap.min.css';
import { apiUrl } from "../config/Config";
import axios from "axios";

const Homepage = () => {
    let navigate = useNavigate();
    const dispatch = useDispatch(); 
    const userdata = useSelector((store) => store.userReducer.userdata);
    
    const [dashboarddata, setdashboarddata] = useState({});
    const [borrowercount, setborrowercount ] = useState(0);
    const [branchcount, setbranchcount ] = useState(0);
    const [staffcount, setstaffcount ] = useState(0);
    const [marketcount, setmarketcount] = useState(0);
      const [showloding, setshowloding] = useState(false);

    const handlefetchdata = async () => {
      setshowloding(true);
      const headers = {
        headers: {
          "Content-Type": "application/json",
          Authorization: "Bearer " + userdata?.token,
        },
      };
      let resp = await axios
        .get(apiUrl + "getdashboarddata", headers)
        .then((res) => {
          // console.log('res >>', res.data)
          if (res.data.status == "success") {
            var prevdata = res?.data;
            setborrowercount(prevdata?.borrowercount);
            setbranchcount(prevdata?.branchcount);
            setstaffcount(prevdata?.staffcount);
            setmarketcount(prevdata?.marketcount);
          } else {
            if(res.data.message == 'invalid user') {
            dispatch({ type: "userdata", payload: {} })
            navigate('/login');
          } else {
            alert(res.data.message);
          }
          }
        })
        .catch((err) => {
          alert(err.message);
        });
  
      setshowloding(false);
    };

    useEffect(() => {
      if (userdata && Object.keys(userdata).length > 0) {
          handlefetchdata();
        
      } else {
        navigate("/login");
      }
    }, []);
    return (
        <div>
          <div className="dashboardrow">
            <div className="dashboardbox">
              <div className="dashboardboxtitlerow">
                <div className="">
                  <p className="dashboardboxtitle">Today’s Stats</p>
                  <p className="dashboardboxsubtitle">Survey Summery</p>
                </div>
                {/* <div className="dashboardbox-exportbtndiv">
                  <img src={exportsvg} className="exportsvg" alt="exporticon" />
                  <p className="exportsvgtext">Export</p>
                </div> */}
              </div>
              <div className="dashboardsummaryrow row">
                <div className="col-md-3">
                  <div className="summaryboxrow">
                    <img src={icon1} className="summaryicon1" />
                    <p className="iconbox1count">{branchcount}</p>
                    <p className="iconbox1subtext">Branch</p>
                    <p className="iconbox1subtext1">+8% from yesterday</p>
                  </div>
                </div>
                <div className="col-md-3">
                  <div
                    className="summaryboxrow"
                    style={{ backgroundColor: "#FFF4DE" }}
                  >
                    <img src={icon2} className="summaryicon1" />
                    <p className="iconbox1count">{staffcount}</p>
                    <p className="iconbox1subtext">Staff</p>
                    <p className="iconbox1subtext1">+5% from yesterday</p>
                  </div>
                </div>
                <div className="col-md-3">
                  <div
                    className="summaryboxrow"
                    style={{ backgroundColor: "#DCFCE7" }}
                  >
                    <img src={icon3} className="summaryicon1" />
                    <p className="iconbox1count">{borrowercount}</p>
                    <p className="iconbox1subtext">Borrower</p>
                    <p className="iconbox1subtext1">+1% from yesterday</p>
                  </div>
                </div>
                <div className="col-md-3">
                  <div
                    className="summaryboxrow"
                    style={{ backgroundColor: "#F3E8FF" }}
                  >
                    <img src={icon4} className="summaryicon1" />
                    <p className="iconbox1count">2</p>
                    <p className="iconbox1subtext">Field Agents</p>
                    <p className="iconbox1subtext1">0.5% from yesterday</p>
                  </div>
                </div>
              </div>
            </div>
            <div
              className="dashboardbox visitorinsightbox"
              style={{ paddingBottom: 0 }}
            >
              <div className="dashboardboxtitlerow">
                <div className="">
                  <p className="dashboardboxtitle">Monthly Insights</p>
                </div>
              </div>
              <div className="vistorchartdiv">
                <VisitorInsight />
              </div>
            </div>
          </div>
          <div className="dashboardrow mt-4">
            <div
              className="dashboardbox visitorinsightbox"
              style={{ paddingBottom: 0, width: "42%" }}
            >
              <div className="dashboardboxtitlerow">
                <div className="">
                  <p className="dashboardboxtitle">Weekly Insights</p>
                </div>
              </div>
              <div className="vistorchartdiv">
                <TotalRevenue />
              </div>
            </div>
            <div
              className="dashboardbox visitorinsightbox"
              style={{ paddingBottom: 0, width: "27%" }}
            >
              <div className="dashboardboxtitlerow">
                <div className="">
                  <p className="dashboardboxtitle">Today’s Progress</p>
                </div>
              </div>
              <div className="vistorchartdiv">
                <Customers />
              </div>
            </div>
            <div
              className="dashboardbox visitorinsightbox"
              style={{ paddingBottom: 0, width: "27%" }}
            >
              <div className="dashboardboxtitlerow">
                <div className="">
                  <p className="dashboardboxtitle">Target vs Reality</p>
                </div>
              </div>
              <div className="vistorchartdiv">
                <TargetReality />
              </div>
            </div>
          </div>
          {/* <div className="dashboardrow mt-4">
            <div
              className="dashboardbox visitorinsightbox"
              style={{ paddingBottom: 0, width: "71%" }}
            >
              <div className="dashboardboxtitlerow">
                <div className="">
                  <p className="dashboardboxtitle">Deals Details</p>
                </div>
                <div className="" style={{ marginLeft: "auto" }}>
                  <select className="dashboard-deals-dropdown form-control">
                    <option selected disabled>
                      Select status
                    </option>
                    <option>Delivered</option>
                    <option>Pending</option>
                    <option>Rejected</option>
                  </select>
                </div>
              </div>
              <div className="vistorchartdiv">
                <table class="table dashboardtable">
                  <thead>
                    <tr>
                      <th>Product Name</th>
                      <th>Location</th>
                      <th>Date - Time</th>
                      <th>Piece</th>
                      <th>Amount</th>
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td>Himalayan Organic Badri Cow Ghee</td>
                      <td>6096 Marjolaine Landing</td>
                      <td>12.09.2019 - 12.53 PM</td>
                      <td>423</td>
                      <td>$34,295</td>
                      <td>
                        <div className="dashboard-delivered-btn">
                          <p>Delivered</p>
                        </div>
                         
                      </td>
                    </tr>
                    <tr>
                      <td>Himalayan Organic Badri Cow Ghee</td>
                      <td>6096 Marjolaine Landing</td>
                      <td>12.09.2019 - 12.53 PM</td>
                      <td>423</td>
                      <td>$34,295</td>
                      <td>
                        <div className="dashboard-delivered-btn" style={{backgroundColor: '#FCBE2D'}}>
                          <p>Pending</p>
                        </div>
                         
                      </td>
                    </tr>
                    <tr>
                      <td>Himalayan Organic Badri Cow Ghee</td>
                      <td>6096 Marjolaine Landing</td>
                      <td>12.09.2019 - 12.53 PM</td>
                      <td>423</td>
                      <td>$34,295</td>
                      <td>
                        <div className="dashboard-delivered-btn" style={{backgroundColor: '#FD5454'}}>
                          <p>Rejected</p>
                        </div>
                         
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div
              className="dashboardbox visitorinsightbox"
              style={{ paddingBottom: 0, width: "27%" }}
            >
              <div className="dashboardboxtitlerow">
                <div className="">
                  <p className="dashboardboxtitle">Sales Mapping by State</p>
                </div>
              </div>
              <div className="vistorchartdiv">
                <IndianMap />
              </div>
            </div>
          </div> */}
        </div>
    )
}   

export default Homepage